// <div data-controller="plan-quote" data-plan-quote-url-value="/app/plan_quote">
//
// 요금제 선택 영역 안에서 현재 선택된 발송량(credit_plan_id)과 결제 주기(payment_cycle)를 읽어
// 견적서 인쇄용 팝업을 연다. 결제 주기 라디오가 없는 화면(온보딩)에서는 월 단위로 기본 처리.
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String };

  open(event) {
    event.preventDefault();

    const creditPlanSelect = this.element.querySelector('select[name*="credit_plan_id"]');
    const creditPlanId = creditPlanSelect && creditPlanSelect.value;
    if (!creditPlanId) {
      alert("발송량을 먼저 선택해주세요.");
      return;
    }

    const checkedCycle = this.element.querySelector('input[name*="payment_cycle"]:checked');
    const paymentCycle = checkedCycle ? checkedCycle.value : "monthly";

    const params = new URLSearchParams({ credit_plan_id: creditPlanId, payment_cycle: paymentCycle });
    window.open(`${this.urlValue}?${params}`, "maily_plan_quote", "width=920,height=1000");
  }
}
